import { useAlarmTypeGroups } from '@hakimo-ui/hakimo/data-access';
import { MultiSelect } from '@hakimo-ui/hakimo/ui-elements';

interface Props {
  selectedAlarmTypeGroupIds: number[];
  label?: string;
  onChange: (ids: number[]) => void;
}

export function AlarmTypeGroupMultiSelect(props: Props) {
  const { selectedAlarmTypeGroupIds, label, onChange } = props;

  const allAlarmTypeGroupsResp = useAlarmTypeGroups('');
  const allAlarmTypeGroups = allAlarmTypeGroupsResp.data?.items;

  const getItems = (query: string) => {
    const filteredGroups = query
      ? allAlarmTypeGroups?.filter((group) =>
          group.name.toLowerCase().includes(query.toLowerCase())
        )
      : allAlarmTypeGroups;
    return filteredGroups?.map((group) => group.alarmTypeGroupId) || [];
  };

  const getDisplayValue = (item: number) => {
    // eslint-disable-next-line eqeqeq
    return (
      allAlarmTypeGroups?.find((group) => group.alarmTypeGroupId == item)
        ?.name || ''
    );
  };

  return (
    <MultiSelect
      label={label}
      value={selectedAlarmTypeGroupIds}
      onChange={onChange}
      getItems={getItems}
      displayValue={getDisplayValue}
      id={(item) => String(item)}
    />
  );
}
